import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function RecallFormScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [saveModal, setSaveModal] = useState(false);

  const handleSaveConfirm = () => {
    setSaveModal(false);
    navigate(isNew ? '/prototype/recalls' : `/prototype/recalls/${id}`);
  };

  return (
    <ScreenFrame
      title={isNew ? 'New recall' : `Edit recall ${id}`}
      actions={
        <>
          <Button component={Link} to={isNew ? '/prototype/recalls' : `/prototype/recalls/${id}`} variant="outlined" size="small">Cancel</Button>
          <Button variant="contained" size="small" onClick={() => setSaveModal(true)}>Save</Button>
        </>
      }
    >
      <Paper sx={{ p: 2, maxWidth: 500 }}>
        <TextField fullWidth label="Product / batch" margin="normal" />
        <TextField fullWidth label="Reason" multiline margin="normal" />
        <TextField fullWidth label="Start date" type="date" margin="normal" />
      </Paper>
      <ConfirmDialog open={saveModal} title="Save recall" message="Save this recall campaign?" onConfirm={handleSaveConfirm} onCancel={() => setSaveModal(false)} />
    </ScreenFrame>
  );
}
